<template>
  <about-us-header />
  <about-back />
  <about-buttons />
  <div class="comissionFees d_none">
    <div class="container">
      <div class="comissionFees-box">
        <a
          :href="docLink"
          download
        ><img
           class="download-img"
           src="../assets/images/download.svg"
           alt=""
         >
          <p>{{ $t("documents.comissionFees") }} АО "СК "Сентрас Иншуранс"</p></a>
      </div>
    </div>
  </div>
</template>

<script>
import aboutUsHeader from "@/components/aboutUsHeader.vue";
import aboutBack from "@/components/AboutBack.vue";
import aboutButtons from "@/components/aboutButtons.vue";

export default {
  components: { aboutUsHeader, aboutBack, aboutButtons },
  computed: {
    docLink() {
      return `/2026_${this.$i18n.locale}.docx`
    }
  }
};
</script>

<style scoped lang="scss">
p {
  margin-bottom: 0;
}
.comissionFees {
  background: #efefef;
  padding-bottom: 15px;
  &-box {
    margin-bottom: 20px;
    padding-top: 15px;
    a {
      display: flex;
      align-items: center;
      p {
        font-family: "Roboto";
        font-style: normal;
        font-weight: 300;
        font-size: 14px;
        line-height: 16px;
        color: #373737;
      }
      img {
        width: 20px;
        height: 20px;
        margin-right: 5px;
      }
    }
  }
}
</style>
